export function setCanonical(path) {
  const link = document.getElementById('canonical-link');
  if (link) {
    link.setAttribute('href', `https://tonehealing.com${path}`);
  }
}
